import * as z from 'zod';
import {
  requiredEmail,
  requiredPhoneSchema,
  requiredText,
} from '@/modules/service-requests/shared/application-utils';
import { asksMaternityBenefit } from '../utils/metlife-rules';

export const metlifeApplySchema = z
  .object({
    typeOfApplication: z.enum(['Employee', 'Spouse', 'Child1', 'Child2', 'Child3'], {
      errorMap: () => ({ message: 'TYPE_OF_APPLICATION_REQUIRED' }),
    }),
    metlifeIdNumber: requiredText('METLIFE_ID_REQUIRED', 50),
    firstName: requiredText('FIRST_NAME_REQUIRED', 100),
    lastName: requiredText('LAST_NAME_REQUIRED', 100),
    email: requiredEmail('EMAIL_REQUIRED'),
    policyApplicantName: requiredText('POLICY_APPLICANT_NAME_REQUIRED', 150),
    designation: requiredText('DESIGNATION_REQUIRED', 150),
    dateOfBirth: z.string().trim().min(1, { message: 'DATE_OF_BIRTH_REQUIRED' }),
    mobileNumber: requiredPhoneSchema('PHONE_NUMBER_REQUIRED'),
    accountNumber: requiredText('BANK_ACCOUNT_REQUIRED', 40),
    branchName: requiredText('BRANCH_NAME_REQUIRED', 150),
    routingNumber: requiredText('ROUTING_NUMBER_REQUIRED', 40),
    departmentId: z.string().trim().min(1, { message: 'DEPARTMENT_REQUIRED' }),
    gender: z.enum(['MALE', 'FEMALE', 'OTHER', 'NA'], {
      errorMap: () => ({ message: 'GENDER_REQUIRED' }),
    }),
    // '' = unanswered. Required only when the maternity question is asked.
    wantsMaternityBenefit: z.enum(['yes', 'no', '']),
  })
  .refine(
    (values) =>
      !asksMaternityBenefit(values.typeOfApplication, values.gender) ||
      values.wantsMaternityBenefit !== '',
    { message: 'MATERNITY_BENEFIT_ANSWER_REQUIRED', path: ['wantsMaternityBenefit'] }
  );

export type MetlifeApplyValues = z.infer<typeof metlifeApplySchema>;
